import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Internal error ")
const _hoisted_2 = {
  key: 2,
  class: "grid m-0 mt-2"
}
const _hoisted_3 = { class: "p-0 col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3" }
const _hoisted_4 = { class: "p-0 col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3" }

import { useRoute } from "vue-router";
import { useQuery, useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";
import NavBar from "@/components/NavBar.vue";
import EditPostCard from "@/components/post/EditPostCard.vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const { loading, result, error } = useQuery(
  gql`
    query getPost($uuid: uuid!) {
      post_by_pk(uuid: $uuid) {
        uuid
        url
        description
        post_tags(order_by: { tag: { name: asc } }) {
          tag {
            name
          }
        }
      }
    }
  `,
  {
    uuid: route.params.id,
  }
);

const mutation = gql`
  mutation UpdatePostByPk(
    $uuid: uuid!
    $description: String!
    $url: String!
    $post_tag_insert_input: [post_tag_insert_input!]!
  ) {
    update_post_by_pk(
      pk_columns: { uuid: $uuid }
      _set: { url: $url, description: $description }
    ) {
      add_post_to_rss
      save_title
    }
    delete_post_tag(where: { post_uuid: { _eq: $uuid } }) {
      affected_rows
    }
    insert_post_tag(objects: $post_tag_insert_input) {
      affected_rows
    }
  }
`;

const { mutate, onDone, loading: mutationLoading } = useMutation(mutation);

onDone(() => {
  router.go(-1);
});

const update = ({ url, description, tags }: { url: string, description: string, tags: string[] }) => {
  let post_tag_insert_input: any[] = [];

  tags.forEach((tag: string) => {
    post_tag_insert_input.push({
      tag: {
        data: { name: tag.toLowerCase() },
        on_conflict: {
          constraint: "tag_name_key",
          update_columns: ["blank"],
        },
      },
      post_uuid: route.params.id
    });
  });

  mutate({
    url,
    description: description ? description : "",
    post_tag_insert_input,
    uuid: route.params.id,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NavBar),
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "spinner"
        }))
      : (_unref(error))
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            class: "mt-5",
            severity: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : (_unref(result))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Button, {
                  label: "Return",
                  class: "p-button-plain p-button-text",
                  icon: "pi pi-angle-left",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(EditPostCard, {
                  onUpdateClick: _cache[1] || (_cache[1] = ($event: any) => (update($event))),
                  post: _unref(result).post_by_pk,
                  loading: _unref(mutationLoading)
                }, null, 8, ["post", "loading"])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})